import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Home from "@/pages/Home";
import RouteDetail from "@/pages/RouteDetail";
import Game from "@/pages/Game";
import Leaderboard from "@/pages/Leaderboard";
import Rewards from "@/pages/Rewards";
import Family from "@/pages/Family";
import Race from "@/pages/Race";
import Referral from "@/pages/Referral";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import PaymentReturn from "@/pages/PaymentReturn";
import AuthCallback from "@/pages/AuthCallback";
import BetaGate from "@/components/BetaGate";

function Protected({ children, admin }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="p-10 text-center">Caricamento...</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/google/callback" element={<AuthCallback />} />
      <Route path="/payment/return" element={<Protected><PaymentReturn /></Protected>} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/routes/:id" element={<RouteDetail />} />
        <Route path="/play/:id" element={<Protected><Game /></Protected>} />
        <Route path="/leaderboard" element={<Protected><Leaderboard /></Protected>} />
        <Route path="/rewards" element={<Protected><Rewards /></Protected>} />
        <Route path="/family" element={<Protected><Family /></Protected>} />
        <Route path="/race" element={<Protected><Race /></Protected>} />
        <Route path="/referral" element={<Protected><Referral /></Protected>} />
        <Route path="/profile" element={<Protected><Profile /></Protected>} />
        <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <BetaGate>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </AuthProvider>
      </BetaGate>
    </I18nProvider>
  );
}

export default App;
